import type { PresenceDictionary } from '../wcContracts'

const presence: PresenceDictionary = {
  history: { title: '既有發布內容', body: '保留企業先前發布的內容與日期。開啟原頁面檢視，不會重新發布。', publishedOn: '發布於 {date}', recordedPages: '條已記錄的發布網址', receptionLoading: '正在讀取接待設定…', receptionUnavailable: '暫時無法讀取接待設定，既有網站內容仍可在下方檢視。' },
  page: { title: '陣地', intro: '查看內容已經出現在哪裡，並完成需要你處理的任務。' },
  overview: { officialSite: '官方網站', searchSubmission: '搜尋收錄提交', needsAction: '需要你處理', online: '在線', submitted: '已提交' },
  queue: { title: '內容任務佇列', all: '全部', needsAction: '需要處理', inProgress: '處理中', published: '已發布', taskCount: '{count} 項任務' },
  state: { manualPrepared: '已準備人工步驟', reviewReady: '等待確認', processing: '處理中', published: '已發布' },
  manual: { title: '完成這次發布', noDuplicate: '沒有產生重複發布。', fallbackBody: '自動發布沒有完成，人工步驟已經準備好。', copy: '複製準備好的內容', openDestination: '開啟目標平台', publicUrl: '發布後的公開網址', markPublished: '標記為已發布', saved: '已儲存為發布完成。' },
  common: { websiteStatus: '網站狀態', distribution: '分發', details: '發布詳細資料', technicalRecord: '查看技術記錄', demoData: '示範資料' },
  site: {
  "back": "網站列表",
  "switchSite": "切換網站",
  "single": "目前專案唯一網站",
  "navigation": "網站管理",
  "manage": "管理網站",
  "manageAirlock": "管理 Airlock",
  "pageCount": "個面向訪客的頁面",
  "viewPages": "查看頁面",
  "todoCount": "{count} 項接待事項待處理",
  "languageBody": "網站內容語言由目標站點決定，不隨介面語言切換。",
  "pagesBody": "這裡列出目前站點版本的頁面與可用接待形態；設定統一在 Airlock 中完成。",
  "noBuild": "尚無可讀取的站點頁面版本。站點產生並驗證後，頁面會顯示在這裡。",
  "machinePages": "機器可讀檔案",
  "readerPages": "訪客頁面",
  "machineNoSlot": "不安裝接待介面",
  "noSlot": "尚無可安裝位置",
  "originalTodo": "回到本次待辦",
  "todoUnavailable": "原待辦目前無法使用，請查看此站點的最新事項。",
  "todoResolved": "這項待辦已處理。",
  "todoOpen": "這項問題仍待處理，提交資料不會直接關閉它。",
  "domain": "網站位址",
  "environmentLabel": "發布環境",
  "installation": "連接方式",
  "connected": "已接入自動部署",
  "guided": "需要引導安裝",
  "connectedBody": "透過已授權的站點連接執行發布；發布前仍會顯示目標與影響範圍。",
  "guidedBody": "該站點尚未接入支援的自動部署方式。可在 Airlock 查看安裝指引，無法在此直接自動發布。",
  "deployBoundary": "瀏覽此處不會產生內容、部署或呼叫模型。",
  "unavailable": "所選網站不在目前可用陣地中。請返回網站列表選擇，不會替你切換至其他網站。",
  "connect": "接入現有網站",
  "create": "建立新網站",
  "emptyBody": "先建立網站陣地，再啟用 Airlock；不會為你猜測發布目標。",
  "connectHelp": "接入需要網站位址、管理授權及支援的連接方式。目前自助接站入口尚未開放，請由專案負責人完成設定後繼續。",
  "createHelp": "新站需要先確認內容與託管位址。目前自助建站入口尚未開放；設定完成後會出現在本列表中。",
  "tabs": {
    "overview": "總覽",
    "pages": "頁面與發布",
    "airlock": "Airlock",
    "deploy": "網域與部署"
  },
  "environment": {
    "production": "正式環境",
    "staging": "測試環境"
  },
  "airlockState": {
    "preparing": "正在準備",
    "ready": "可以啟用",
    "publishing": "正在發布",
    "live": "接待中",
    "paused": "已暫停",
    "failed": "需要處理"
  },
  "slot": {
    "widget": "浮動接待",
    "inline": "頁面內接待",
    "focus": "專注接待"
  }
},
  material: {
  "pending_domain": "資料已提交，等待確認使用範圍；尚未進入接待知識。",
  "awaiting_knowledge_confirmation": "已確認為公開資料，知識仍待整理與確認；尚未同步接待。",
  "private_only": "這份資料僅供內部使用，不能用於對外回答。你可以補充公開資料，或設定回答邊界。",
  "synced": "公開資料已進入本專案的接待知識，可以返回 Airlock 重新測試。",
  "loadError": "暫時無法讀取資料進度，不能據此判斷資料未提交。請稍後重新開啟。",
  "addMore": "繼續補充資料"
},
  workspace: {
    loading: '正在讀取已授權陣地…', error: '沒有讀到最新陣地狀態。', empty: '目前還沒有已授權陣地或完成驗真的發布。', authorisedSites: '個已授權站點工作區', verifiedRoutes: '條已驗真的線上路徑', preservedIssues: '個已保留待處理問題', eyebrow: '站點工作區', title: '所有線上陣地與最近一次驗真發布', siteCount: '{count} 個站點', mode: '站點模式', managedStatic: 'Navigator 託管靜態站點', languages: '支援語言', lastDeploy: '最近發布', machine: '機器層', noRelease: '這個站點還沒有記錄行動發布。',
    status: { configured: '已設定', building: '正在構建', ready: '可以發布', deploying: '正在部署', state_unknown: '狀態需要驗真', live: '上線', failed: '需要處理' }, machineStatus: { pending: '正在準備', verified: '已驗證', unknown: '未知 · 已安全停下', failed: '失敗' },
  },
}

export default presence
